import { Image } from "@chakra-ui/react";
import React from "react";

const NavbarButton = ({ setVisible }) => {
  return (
    <Image
      w="50px"
      h="50px"
      position="absolute"
      top="10px"
      right="10px"
      zIndex="2"
      src="/assets/menu.png"
      alt="menu"
      onClick={() => setVisible(true)}
    />
  );
};

export default NavbarButton;
